import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import {
  InfoFullIcon,
  CloseRoundFullIcon,
  CheckFillIcon,
  WarningFillIcon
} from 'src/components/shared/ui/Icons'

import { theme } from 'src/providers/ThemeProvider'

export default function AlertIconTitle({ type }: { type: AlertType }): JSX.Element {
  switch (type) {
    case AlertType.INFO:
      return (
        <InfoFullIcon
          fontSize="large"
          htmlColor={theme.colors.byzantineBlue200}
          sx={{ fontSize: '32px' }}
        />
      )
    case AlertType.SUCCESS:
      return <CheckFillIcon htmlColor={theme.colors.seaGreen200} sx={{ fontSize: '32px' }} />
    case AlertType.ERROR:
      return <CloseRoundFullIcon htmlColor={theme.colors.red01} sx={{ fontSize: '32px' }} />
    case AlertType.WARNING:
      return <WarningFillIcon htmlColor={theme.colors.saffron200} sx={{ fontSize: '32px' }} />
    default:
      return <></>
  }
}
